(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["best-categories"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.best-categories__carousel').forEach((carousel) => {
      const track = carousel.querySelector('[data-best-categories-track]');
      if (!track) return;

      carousel.querySelectorAll('.best-categories__nav').forEach((btn) => {
        btn.addEventListener('click', () => {
          const scrollAmount = track.clientWidth * 0.7;
          track.scrollBy({
            left: btn.dataset.direction === 'next' ? scrollAmount : -scrollAmount,
            behavior: 'smooth',
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      document.querySelectorAll('.prz-del__count').forEach(function (el) {
        var cutoff = parseInt(el.dataset.przCutoff, 10) * 1000;
        var left = cutoff - Date.now();
        var out = el.querySelector('[data-prz-timer]');
        if (!out || isNaN(cutoff)) return;

        if (left <= 0) { el.hidden = true; return; }

        var h = Math.floor(left / 3600000);
        var m = Math.floor((left % 3600000) / 60000);
        var sec = Math.floor((left % 60000) / 1000);
        out.textContent = h > 0 ? h + ':' + pad(m) + ':' + pad(sec) : pad(m) + ':' + pad(sec);
        el.hidden = false;
      });
    }

    function position() {
      var wrap = document.querySelector('[data-prz-del]');
      var price = document.querySelector('#tee-artwork-form .tee-product-price');
      if (!wrap || !price) return false;

      var box = wrap.querySelector('.prz-del');
      var inline = wrap.querySelector('[data-prz-inline]');
      var moved = true;

      if (box && price.nextElementSibling !== box) {
        price.insertAdjacentElement('afterend', box);
      }

      if (inline) {
        if (price.lastElementChild !== inline) {
          price.appendChild(inline);
        }
        inline.hidden = false;
      }

      if (box && !wrap.contains(box)) {
        wrap.style.display = 'none';
        var group = wrap.closest('[data-testid="group-block"]');
        if (group) {
          var visible = Array.prototype.filter.call(group.children, function (ch) {
            if (ch === wrap) return false;
            if (ch.hidden) return false;
            var cs = window.getComputedStyle(ch);
            if (cs.display === 'none') return false;
            if (ch.tagName === 'SCRIPT' || ch.tagName === 'STYLE') return false;
            return ch.textContent.trim() !== '' || ch.querySelector('img, svg, video, iframe');
          });
          if (visible.length === 0) {
            group.style.display = 'none';
          }
        }
      }

      return moved;
    }

    function boot() {
      tick();

      var tries = 0;
      var timer = setInterval(function () {
        if (position() || ++tries > 40) clearInterval(timer);
      }, 250);

      var form = document.getElementById('tee-artwork-form');
      if (form && 'MutationObserver' in window) {
        new MutationObserver(function () { position(); })
          .observe(form, { childList: true, subtree: true });
      }
    }

    boot();
    setInterval(tick, 1000);
    document.addEventListener('shopify:section:load', function () {
      tick();
      position();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-prz-sc-open]');
    if (opener) {
      var dlg = document.getElementById(opener.dataset.przScOpen);
      if (dlg) dlg.showModal();
      return;
    }

    var closer = e.target.closest('[data-prz-sc-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }

    // Backdrop kattintásra zárás
    if (e.target.classList && e.target.classList.contains('prz-sc-modal')) {
      var rect = e.target.getBoundingClientRect();
      var inside = e.clientX >= rect.left && e.clientX <= rect.right &&
                   e.clientY >= rect.top && e.clientY <= rect.bottom;
      if (!inside) e.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
